module.exports = __webpack_public_path__ + "static/img/weather29.1d85aab4.png";